import { useEffect, useState } from "react";

export default function NumberSelectionSimulator({numbers}){

    
    var randomNums = Array.from({length: numbers}, () => Math.floor(Math.random() * 4215));

    const [random, setRandom] = useState(randomNums);

    useEffect(() => {
        const interval = setInterval(function() {
            setRandom(Array.from({length: numbers}, () => Math.floor(Math.random() * 4215)));
        }, 80);


        return () => {
            clearInterval(interval);
        }
    }, [])


    return(
        <h3 className="text-muted">
            {random.join(', ')}
        </h3>
    );

}